import { render, staticRenderFns } from "./Shell.vue?vue&type=template&id=63596a09&"
import script from "./Shell.vue?vue&type=script&lang=js&"
export * from "./Shell.vue?vue&type=script&lang=js&"
import style0 from "./Shell.vue?vue&type=style&index=0&id=63596a09&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports